(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryListV2Controller', CompanyServiceCategoryListV2Controller);

    CompanyServiceCategoryListV2Controller.$inject = ['entity', '$scope', '$state', 'ServiceCategory', 'ServiceCategorySearch', 'ParseLinks', 'CompanyInfoQuery', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceCategoryCustom', 'QueryParamsService'];

    function CompanyServiceCategoryListV2Controller(entity, $scope, $state, ServiceCategory, ServiceCategorySearch, ParseLinks, CompanyInfoQuery, AlertService, pagingParams, paginationConstants, ServiceCategoryCustom, QueryParamsService) {
        var vm = this;

        vm.isEventMode = false;
        if (entity && entity.mode && entity.mode == 'EVENT')
            vm.isEventMode = true;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;


        // vm.confirmDelete = confirmDelete;


        loadAll();
        loadPage();

        function loadAll() {
            //if (pagingParams.search) {
            //    ServiceCategorySearch.query({
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceCategory.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceCategories = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            loadCompanyInfo();
        }

        function loadCompanyInfo() {

        }

        function loadPage() {
            loadCategories();
            //vm.page = page;
            //vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        vm.editCategory = function (category) {
            $state.go('supplierPanel-v2.companyServiceCategoryList.edit', {id: category.id});
        }

        vm.newCategory = function () {
            $state.go('supplierPanel-v2.companyServiceCategoryList.new');
        }

        vm.searchKeyPress = function (keyEvent) {
            if (keyEvent.which === 13) {
                searchCategories();
            }
        }

        function loadCategories() {
            ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {
                vm.serviceCategories = result.filter(function (v) {
                        return (v.categoryName != "DEFAULT_CATEGORY")
                    }
                );
                var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        vm.searchCategories()
                }

            });
        }

        vm.searchCategories = function () {

            if (!vm.searchQuery) {
                QueryParamsService.removeFilter('searchText')
                loadCategories();
                return;
            }else QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.serviceCategories = vm.serviceCategories.filter(function (c) {
                if (c.categoryName.includes(vm.searchQuery))
                    return true;
            })
        }

        vm.clearSearch = function () {
            QueryParamsService.removeFilter('searchText')
            vm.searchQuery = null;
            vm.searchCategories();
        }


    }
})();
